export default "__VITE_ASSET__C934iM6g__"